import React, { useState, useRef } from "react";

const ScrollText = () => {
  let textMove = useRef();
  let translate = 0;
  const [current, setCurrent] = useState(0);
  const [animationTime, setAnimationTime] = useState(50);

  const handleTouch = (e, touch) => {
    let part = document.querySelector(".part-text");
    if (!touch) {
      part.style.animation = `scroll ${animationTime}s linear 0s infinite running`;
    } else {
      part.style.animation = `scroll ${animationTime}s linear 0s infinite paused`;
      textMove.current = e.touches[0].clientX;
    }
  };

  const handleMouseTouch = (e, touch) => {
    let part = document.querySelector(".part-text");
    if (touch) {
      part.style.animation = `scroll ${animationTime}s linear 0s infinite paused`;
    } else {
      part.style.animation = `scroll ${animationTime}s linear 0s infinite running`;
      textMove.current = e.clientX;
    }
  };
  /*
  const handleRemainingTime = () => {
    const part = document.querySelector(".part-text");
    const translateX = part.style.transform.slice(11);
    const correctTranslateX = parseInt(
      translateX.slice(0, translateX.length - 3)
    );
    if (!isNaN(correctTranslateX)) {
      const partRect = part.getBoundingClientRect();
      const width = partRect.width / 2;
      const newWidth = correctTranslateX + width;
      // formula za izracunavanje novog vremena
      const percent = (newWidth * 100) / width;
      const newTime = (percent * animationTime) / 100;
      if (newTime > 10) {
        console.log("Otiso levo");
      }
      if (newTime < 0) {
        console.log("Otiso desno");
      }
      console.log("Vreme" + newTime);
      // azuriranje pozicije ???

      animationTime = newTime;

      part.style.animationDuration = animationTime;
    }
  };
*/
  const updateTimeRemaining = (e) => {
    const part = document.querySelector(".part-text");
    let partText = document.querySelector(".part-text-wrapper");

    const partRect = part.getBoundingClientRect();
    const width = partRect.width / 2;

    const partLeft = part.getBoundingClientRect().left;
    const partTextLeft = partText.getBoundingClientRect().left;

    let road = 0;

    if (partLeft > 0) {
      road += partTextLeft - partLeft;
    } else {
      road += Math.abs(partLeft) + partTextLeft;
    }
    let newTime = (50 * road) / width;
    part.style.animationDuration = 50 - newTime + "s";
    setAnimationTime(50 - newTime);
  };

  const handleMouseClick = (e, click) => {
    let part = document.querySelector(".part-text");
    //console.log(part);
    if (click) {
      textMove.current = e.clientX;
      part.addEventListener("mousemove", handleMoveMouse);
      translate = 0;
    } else {
      textMove.current = false;
      setCurrent(current + translate);
      updateTimeRemaining(e);
      part.removeEventListener("mousemove", handleMoveMouse);
    }
  };

  const handleScroll = () => {
    let part = document.querySelector(".part-text");

    part.style.animationDuration = "50s";
    part.style.transform = `translateX(0)`;
    part.style.animationDuration = "50s";
    setAnimationTime(50);
    setCurrent(0);
  };

  const handleMoveMouse = (e) => {
    let startX, currentX, differenceX;

    let part = document.querySelector(".part-text");
    let partText = document.querySelector(".part-text-wrapper");
    const partLeft = part.getBoundingClientRect().left;
    const partTextLeft = partText.getBoundingClientRect().left;

    startX = textMove.current;
    currentX = e.clientX;
    differenceX = startX - currentX;

    let road = 0;

    if (partLeft > 0) {
      road += partTextLeft - partLeft;
    } else {
      road += Math.abs(partLeft) + partTextLeft;
    }

    if (differenceX > 0) {
      if (road >= part.getBoundingClientRect().width / 2) {
        console.log("Pevukli ste izvan kraja");
        part.style.transform = `translateX(-${translate})`;
        part.style.animationDuration = "50s";
        setCurrent(0);
        textMove.current = false;
        part.removeEventListener("mousemove", handleMoveMouse);
        return;
      }
      part.style.transform = `translateX(${current + currentX - startX}px)`;
      translate = currentX - startX;
    } else {
      if (road >= 0) {
        part.style.transform = `translateX(${current + currentX - startX}px)`;
        translate = currentX - startX;
      }
    }
  };

  return (
    <div className="part-text-wrapper">
      <p
        className="part-text"
        onTouchEnd={(e) => handleTouch(e, false)}
        onTouchStart={(e) => handleTouch(e, true)}
        // onTouchMove={(e) => handleMove(e, true)}
        onMouseEnter={(e) => handleMouseTouch(e, true)}
        onMouseLeave={(e) => handleMouseTouch(e, false)}
        //onMouseMove={(e) => handleMove(e, false)}
        onMouseDown={(e) => handleMouseClick(e, true)}
        onMouseUp={(e) => handleMouseClick(e, false)}
        onAnimationIteration={() => handleScroll()}
      >
        Ово је апликација за управљање БЗР документима. Ово је апликација за управљање БЗР документима. Ово је апликација за управљање БЗР документима. 
        Ово је апликација за управљање БЗР документима. Ово је апликација за управљање БЗР документима. Ово је апликација за управљање БЗР документима. 
        Ово је апликација за управљање БЗР документима. Ово је апликација за управљање БЗР документима. Ово је апликација за управљање БЗР документима. 
        Ово је апликација за управљање БЗР документима. Ово је апликација за управљање БЗР документима. Ово је апликација за управљање БЗР документима. 
      </p>
    </div>
  );
};

export default ScrollText;
